import React from 'react';
import SMSSendTab from './SMSSend';

export default function SmsOpen(props) {
  return <SMSSendTab {...props} />;
}
